module.exports = __webpack_public_path__ + "img/cat_fish.32f847e7.png";